export default "__VITE_ASSET__N5lXY$3i__"